import React from "react";
import { X, AlertTriangle } from "lucide-react";

const SENTIMENT_CLS = {
  positive: "bg-emerald-50 text-emerald-700 border-emerald-200",
  neutral: "bg-zinc-50 text-zinc-700 border-zinc-200",
  negative: "bg-rose-50 text-rose-700 border-rose-200",
};

export default function ResponseModal({ response, onClose }) {
  if (!response) return null;
  const sent = response.sentiment || "neutral";
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      data-testid="response-modal"
      onClick={onClose}
    >
      <div
        className="bg-white border border-zinc-200 rounded-[6px] max-w-3xl w-full max-h-[88vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-5 border-b border-zinc-200">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="label-eyebrow">
                {response.engine?.toUpperCase() || "RESPONSE"}
              </span>
              <span
                className={`mono text-[10px] uppercase tracking-[0.14em] px-2 py-0.5 rounded-full border ${SENTIMENT_CLS[sent]}`}
              >
                {sent}
              </span>
            </div>
            <h3 className="display mt-1 text-lg font-bold tracking-tight">
              {response.prompt_text || response.title || "AI response"}
            </h3>
          </div>
          <button
            onClick={onClose}
            data-testid="response-modal-close"
            className="text-zinc-400 hover:text-zinc-900 transition-colors"
          >
            <X size={18} />
          </button>
        </div>
        <div className="overflow-auto flex-1 p-5 space-y-4">
          {response.reason && (
            <div className="flex items-start gap-2 text-sm bg-rose-50 border border-rose-200 text-rose-800 p-3 rounded-[4px]">
              <AlertTriangle size={14} className="mt-0.5 shrink-0" />
              <div>
                <div className="font-medium">Why the AI flagged this as negative</div>
                <div className="mt-1">{response.reason}</div>
              </div>
            </div>
          )}
          <div>
            <div className="label-eyebrow">Full response</div>
            <pre className="mt-2 whitespace-pre-wrap text-sm text-zinc-800 bg-[#fafafa] border border-zinc-200 rounded-[4px] p-3 max-h-[60vh] overflow-auto">
              {response.response_text || response.content || "(empty)"}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
}
